// extracted by mini-css-extract-plugin
export default {"routerWrapper":"router_routerWrapper__MkyD3","bodyContent":"router_bodyContent__hwNiC"};